require("./SurveySummary.less");

const React = require("react");
const T = React.PropTypes;

const auditSummaryLoadDispatchers = require("~/events/auditLoad/auditSummaryLoadDispatchers.js");
const SurveyType = require("~/types/Survey.js").PropType;

const SummaryPage = require("./SummaryPage/SummaryPage.jsx");
const SurveyOverview = require("./SurveyOverview/SurveyOverview.jsx");
const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const SurveyLoadError = require("../SurveyLoadError/SurveyLoadError.jsx");
const PrintButton = require("./PrintButton/PrintButton.jsx");
const PdfButton = require("./PdfButton/PdfButton.jsx");

const SurveySummary = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired
    },
    componentWillMount() {
        if (this.props.Survey.Pages === null) {
            auditSummaryLoadDispatchers.LoadAudit(
               this.props.Survey.Type,
               this.props.Survey.FacilityNumber,
               this.props.Survey.GUID);
        }
    },
    componentWillReceiveProps(newProps) {
        if (!newProps.Survey.LoadError
            && !newProps.Survey.IsLoading) {
            if (this.props.Survey.GUID !== newProps.Survey.GUID) {
                auditSummaryLoadDispatchers.LoadAudit(
                    newProps.Survey.Type,
                    newProps.Survey.FacilityNumber,
                    newProps.Survey.GUID);
            }
        }
    },
    render() {
        let message = this.GetMessage();

        if (message) {
            return (<MajorMessage>
                {message}
            </MajorMessage>);
        }

        const surveyIDPath = [
            this.props.Survey.Type,
            this.props.Survey.GUID];

        const pages = this.props.Survey.Pages.map((p) => {
            return (<SummaryPage key={p.GUID}
                             Page={p}
                             SurveyIDPath={surveyIDPath}
                             IsReadOnly={true} />);
        });

        const surveyOverview = <SurveyOverview Survey={this.props.Survey} />

        return (<span><div id={"mypdfroot"} className="cs-SurveySummary">
            {surveyOverview}
            {pages}
            <div className={"cs-SurveySummary__bottomButtons"}>
                <PrintButton Print={this.Print} />
                <PdfButton Save={this.Save}></PdfButton>
            </div>
        </div>
            <div id="printer"></div>
        </span>);
    },
    Print() {
        window.print();
    },
    Save() { 
        var doc = new jsPDF('p', 'pt', 'letter');
        var source = $('#mypdfroot')[0];
        
        var specialElementHandlers = { 
            '#bypassme' : function (element, renderer) { 
                return true; 
            }
        };

        const margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 400
        };

        doc.fromHTML(
            source,
            margins.left,
            margins.top, 
            {
                'width': margins.width,
                'elementHandlers' : specialElementHandlers
            }, 
            
            function (dispose) {
                doc.save(Date().toString() + '.pdf'); 
            }, 
            margins
            );
    }, 
    /*Save() {
        var container = document.getElementById("printer");
        container.style = `width:1800px;background-color:#fff;`;
        var elem = document.getElementById("mypdfroot");
        container.innerHTML = `<div id="shifter" className="cs-PDFScale">` + elem.innerHTML + "</div>";
        //container.innerHTML = `<div id="shifter" style="margin:450px;width:900px;background-color:#fff;transform:scale(2,2);">` + elem.innerHTML + "</div>";
        var h = container.clientHeight;
        var shifter = container.querySelector("#shifter");
        shifter.style.paddingTop = String(Math.floor(h / 2) + 25) + 'px';
        shifter.style.paddingBottom = String(Math.floor(h / 2) + 25) + 'px';
        //var exportsection = container.querySelector("#exportsection");
        //exportsection.style = "display:none";

        html2canvas(container).then(canvas => {

            var imgData = canvas.toDataURL("image/jpeg", 1.0);

            var pdf = new jsPDF("p", "pt", "letter");
            var width = 20;

            var height = Math.floor(width * (1.294));
            var trueheight = (width / canvas.width) * canvas.height;

            var pages = Math.floor(trueheight / height) + 1;

            for (var page = 1; page <= pages; page++) {
                var adjustHeight = -1 * (page - 1) * height;
                console.log(adjustHeight);
                pdf.addImage(imgData, 'JPG', 0, adjustHeight, width, trueheight);
                if (page != pages) pdf.addPage();
            }

            // undo the additional html we wrote to:
            container.innerHTML = "";
            container.style = "";

            pdf.save("export.pdf");
        });
    },*/
    GetMessage() {
        if (this.props.Survey.LoadError) {
            return (<SurveyLoadError Error={this.props.Survey.LoadError } />);
        }

        if (this.props.Survey.IsLoading
            || !(this.props.Survey.Pages || []).length) {
            return (<MajorLoading />);
        }

        return null;
    }
});

module.exports = SurveySummary;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SurveySummary.jsx